import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import LoginView from '../views/LoginView.vue'
import StatSearch from '@/views/StatSearch.vue'
import { authStore } from "../store/index";
import PageNotFound from "@/views/404Page.vue"
import profilePage from "@/views/ProfileView.vue"
import detailedView from "@/views/DetailedPlayView.vue"
import gameManager from "@/views/GameManagerView.vue"
import dataCollector from '@/views/DataCollectorView.vue'
import matchSelector from '@/views/MatchSelectorView.vue'
import MatchManager from '@/components/MatchManager.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'loginView',
    component: LoginView,
    meta: { title: 'Hyperlayer Home' }
  },
  {
    path: '/statSearch:query?',
    name: 'statSearch',
    component: StatSearch,
    meta: { title: 'Stat Search' },
    props: route => ({ query: route.query.q }) //statSearch?q=PARAM gives props q = PARAM
  },
  {
    path: '/play:query?',
    name: 'playView',
    component: detailedView,
    meta: { title: 'Play View' },
    props: route => ({ query: route.query.q })
  },
  {
    path: "/:catchAll(.*)",
    component: PageNotFound,
    meta: { title: 'Stat Search' }
  },
  {
    path: "/profile",
    component: profilePage,
    meta: { title: 'My Profile' }
  },
  {
    path: '/gameManager',
    name: 'gameManager',
    component: gameManager,
    meta: { title: 'Game Manager' }
  },
  {
    path: '/vscore:query?',
    name: 'vscore',
    component: dataCollector,
    meta: { title: 'VScore' },
    props: route => ({ query: route.query.q })
  },
  {
    path: '/vscore/match',
    name: '/vscore',
    component: matchSelector,
    props: route => ({ query: route.query.q }),
    meta: { title: 'VScore' },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/'];
  const authRequired = !publicPages.includes(to.path);
  const auth = authStore();
  document.title = to.meta.title as string

  if (to.path === "/callback") {
    console.log("router")
    await auth.loginCallback();
    router.push("/");
  }
  if (authRequired && !auth.user) {
    console.log("router interfere")
    //auth.returnUrl = to.fullPath;
    //console.log("not logged in")
    return '/';
  }

  // Check for match ID param when trying to navigate to vscore - if none, redirect to match selector
  if (to.path === '/vscore') {
    if (Object.keys(to.query).length == 0 || to.query.q == null || to.query.q == "") {
      router.push("/vscore/match")
    }
  }
});


export default router
